// Include Lightbox 
import PhotoSwipeLightbox from 'photoswipe/lightbox';


document.addEventListener("turbo:load", () => {    
  const lightbox = new PhotoSwipeLightbox({
    // may select multiple "galleries"
    gallery: '.gallery-view.clickable.orb-grid',
    
    // Elements within gallery (slides)
    children: 'figure',
    
    // setup PhotoSwipe Core dynamic import
    pswpModule: () => import('photoswipe'),
    // getViewportSizeFn: function(options, pswp) {
    //   return {
    //     x: window.innerWidth,
    //     y: window.innerHeight
    //   };
    // }
  });
  lightbox.init();
})
